<template>
  <app-layout class="nearby-list-page-template">
    <Row type="flex" justify="center">
      <Col :span="24">
        <Tabs v-model="tabName" :animated="false" v-on:on-click="switchTab">
          <TabPane label="Latest" name="latest"></TabPane>
          <TabPane label="Nearest" name="nearest"></TabPane>
        </Tabs>
        <p style="padding:0 10px 10px;" v-if="filterURI">
          <span style="text-transform:capitalize">
            <a @click="clearFilter()">All</a>&nbsp;&nbsp;
            <Icon type="ios-arrow-right"></Icon>&nbsp;&nbsp;{{filterURI.split(":")[0]}}
            :&nbsp;{{filterURI.split(":")[1]}}
          </span>
        </p>
      </Col>
      <Col :span="24" v-for="(item, k) in nearby.data.data" :key="k">
        <Card shadow :style="{borderRadius: '0', cursor: 'pointer', borderTop: '1px solid #F2F2F2'}" :padding="0">
          <UserListItemComponent :item="item">
            <template slot="sub-title">
              <small style="color:#aaa"><Icon type="location"></Icon> {{convertToKM(item.check_in_details.distance)}} km &middot; <timeago :since="item.updated_at"></timeago></small>
            </template>
          </UserListItemComponent>
        </Card>
      </Col>
    </Row>
  </app-layout>
</template>

<script>
import UserListItemComponent from '@/components/UserListItemComponent'
import WindowScrollEvent from 'vue-scroll-event/mixins/WindowOnScroll'

export default {
  name: 'NearbyListComponent',
  mixins: [WindowScrollEvent],
  components: {
    UserListItemComponent
  },
  computed: {
    userInfo: {
      get () {
        return this.$store.state.user.info
      }
    },
    nearby: {
      get () {
        return this.$store.state.nearby.nearbyPeople
      }
    }
  },
  watch: {
    $route: function (n, o) {
      if (n) this.setTab(n)
    }
  },
  mounted () {
    this.setTab(this.$route)
  },
  methods: {
    onWindowScrolledBottom () {
      if (this.nearby.data.next_link && !this.nearby.isLoading) { this.$store.dispatch('nearby/getNextPageNerby', { url: this.nearby.data.next_link }) }
    },
    clearFilter () {
      this.tabName = ('tab' in this.$route.query && this.$route.query.tab) ? this.$route.query.tab : 'latest'
      this.$router.replace({path: '/nearby?tab=' + this.tabName})
    },
    loadPeople () {
      if ('places' in this.userInfo && 'work' in this.userInfo.places && this.userInfo.places.work) {
        let query = '?category=latest_only&rad=5&summarize=0&radius_offset=0'
        query += '&sort_by=' + this.tabName
        query += '&lat=' + this.userInfo.places.work.latitude + '&lng=' + this.userInfo.places.work.longitude

        if (this.filterURI) { query += '&filter_by=' + this.filterURI }

        this.$store.dispatch('nearby/getNearbyPeople', {query}, {root: 1})
      }
    },
    switchTab (n) {
      this.tabName = n
      this.filterURI = ('filter' in this.$route.query && this.$route.query.filter) ? this.$route.query.filter : null

      if (this.filterURI) {
        this.$router.replace({path: '/nearby',
          query: {
            filter: this.filterURI,
            tab: this.tabName
          }})
      } else { this.$router.replace({path: '/nearby?tab=' + this.tabName}) }
    },
    setTab (n) {
      this.tabName = ('tab' in n.query && n.query.tab) ? n.query.tab : 'latest'
      this.filterURI = ('filter' in n.query && n.query.filter) ? n.query.filter : null

      if (this.filterURI) {
        this.$router.replace({path: '/nearby',
          query: {
            filter: this.filterURI,
            tab: this.tabName
          }})
      } else { this.$router.replace({path: '/nearby?tab=' + this.tabName}) }

      this.loadPeople()
    },
    convertToKM (d) {
      let distsance = Math.floor(d)
      return (distsance == 0) ? Math.round(d * 100) / 100 : distsance
    }
  },
  data () {
    return {
      tabName: 'latest',
      filterURI: null
    }
  }
}
</script>
